interface ComputerWithSoundBarSVGProps {
  color: string;
  style: React.CSSProperties;
}

const ComputerWithSoundBarSVG = ({
  color,
  style,
}: ComputerWithSoundBarSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="61"
    height="52"
    viewBox="0 0 61 52"
    fill="none"
  >
    <g clipPath="url(#clip0_767_2978)">
      <path
        d="M60.2562 38.5086C60.2562 40.513 58.6434 42.1369 56.6527 42.1369H4.34742C2.35674 42.1369 0.743958 40.513 0.743958 38.5086V4.37728C0.743958 2.3729 2.35674 0.749023 4.34742 0.749023H56.6497C58.6404 0.749023 60.2532 2.3729 60.2532 4.37728V38.5086H60.2562Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.46344 35.0334H56.5366"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.7482 43.1409V51.2513"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.2518 42.1367V51.2508"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.1748 51.251H41.8251"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.5178 38.446H30.4851V38.4783H30.5178V38.446Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.5477 9.30566V27.6297"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.6376 15.2051V21.7305"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.7307 13.1167V23.8187"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.8237 16.73V20.2024"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.3624 15.2051V21.7305"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.2693 13.1167V23.8187"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.1763 16.73V20.2024"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.3709 6.53735H18.7018C17.461 6.53735 16.4552 7.55003 16.4552 8.7994V11.4869"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.6292 6.53711H42.2983C43.5391 6.53711 44.5449 7.54979 44.5449 8.79915V11.4866"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.6291 30.398H42.2982C43.539 30.398 44.5448 29.3853 44.5448 28.136V25.4485"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.3708 30.398H18.7017C17.4609 30.398 16.4551 29.3853 16.4551 28.136V25.4485"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_767_2978">
        <rect width="61" height="52" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default ComputerWithSoundBarSVG;
